var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 23.5a11.5 11.5 0 1 1 11.5-11.5 11.5128 11.5128 0 0 1 -11.5 11.5zm0-22a10.5 10.5 0 1 0 10.5 10.5 10.512 10.512 0 0 0 -10.5-10.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.5 12.5h6.5506a2.5 2.5 0 1 0 0-1h-6.5506a.5.5 0 0 0 0 1zm9-2a1.5 1.5 0 1 1 -1.5 1.5 1.5017 1.5017 0 0 1 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 18.5a2.5041 2.5041 0 0 0 2.4494-2h6.5506a.5.5 0 0 0 0-1h-6.5506a2.5 2.5 0 1 0 -2.4494 3zm0-4a1.5 1.5 0 1 1 -1.5 1.5 1.5017 1.5017 0 0 1 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 10.5a2.5041 2.5041 0 0 0 2.4494-2h6.5506a.5.5 0 0 0 0-1h-6.5506a2.5 2.5 0 1 0 -2.4494 3zm0-4a1.5 1.5 0 1 1 -1.5 1.5 1.5017 1.5017 0 0 1 1.5-1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting_icon.a0d4e50fe2da7160c5df6daf035f1e21.svg";
export { ForwardRef as ReactComponent };